var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5955_29849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5634 11.7669L10.7748 9.67547V5.41523C10.7748 4.98687 10.4286 4.64062 10.0002 4.64062C9.57184 4.64062 9.22559 4.98687 9.22559 5.41523V10.0628C9.22559 10.3068 9.34023 10.5369 9.53543 10.6825L12.6338 13.0063C12.7732 13.1109 12.9359 13.1612 13.0978 13.1612C13.334 13.1612 13.5664 13.0551 13.7182 12.8506C13.9755 12.5089 13.9057 12.0233 13.5634 11.7669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48566 0 0 4.48566 0 10C0 15.5143 4.48566 20 10 20C15.5143 20 20 15.5143 20 10C20 4.48566 15.5143 0 10 0ZM10 18.4508C5.34082 18.4508 1.54918 14.6592 1.54918 10C1.54918 5.34082 5.34082 1.54918 10 1.54918C14.66 1.54918 18.4508 5.34082 18.4508 10C18.4508 14.6592 14.6592 18.4508 10 18.4508Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5955_29849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockicon);
export default __webpack_public_path__ + "static/media/clockicon.7e4b87a175d91339f8297ffb1c159f2d.svg";
export { ForwardRef as ReactComponent };